//試用表單
// TSK 尖針清單
export const SHARP_OPTIONS = [
  '34G/9mm 隱形針',
  '33G/4mm',
  '33G/13mm',
  '32G/4mm',
  '32G/13mm',
  '30G/4mm',
  '30G/13mm',
  '27G/13mm'
]

// TSK 鈍針清單
export const CANNULA_OPTIONS = [
  '30G/25mm',
  '27G/50mm',
  '27G/38mm',
  '27G/25mm',
  '25G/50mm',
  '25G/38mm',
  '22G/70mm',
  '22G/50mm',
  '22G/38mm'
]